import { whyChooseUs } from '../../../mocks/homeData';

export default function WhyChooseUs() {
  return (
    <section className="relative overflow-hidden py-0" id="why-us">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[680px]">
        {/* Left image */}
        <div className="relative min-h-[400px] lg:min-h-0 order-2 lg:order-1">
          <img
            src="https://public.readdy.ai/ai/img_res/80f4f99afb90591cb3bff1d808b9e159.jpg"
            alt="DBN Garage XPEL certified technician applying paint protection film"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0A0A0A]/60" />
          {/* Float tag */}
          <div className="absolute top-8 right-8 bg-[#FF6B35] rounded-xl px-4 py-2.5 text-center">
            <p className="text-white font-black text-sm">XPEL Certified</p>
            <p className="text-white/70 text-xs">Authorized Installer</p>
          </div>
          {/* Quote card */}
          <div className="absolute bottom-8 left-8 right-8 lg:right-auto lg:max-w-xs bg-[#0A0A0A]/90 backdrop-blur-md border border-white/15 rounded-2xl p-5">
            <div className="flex items-center gap-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill text-[#FF6B35] text-sm" /></span>
              ))}
            </div>
            <p className="text-white/80 text-sm italic">&ldquo;The only shop in CT I'd trust with my Ferrari.&rdquo;</p>
            <span className="text-gray-500 text-xs font-semibold">— Daniel M., West Hartford CT</span>
          </div>
        </div>

        {/* Right dark content */}
        <div className="bg-[#0A0A0A] px-10 lg:px-16 py-24 flex flex-col justify-center relative order-1 lg:order-2">
          <div className="absolute left-0 top-20 bottom-20 w-0.5 bg-gradient-to-b from-transparent via-[#FF6B35]/50 to-transparent" />
          <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
            <span className="w-6 h-px bg-[#FF6B35]" />
            Why DBN Garage
          </span>
          <h2 className="font-display font-black text-4xl lg:text-5xl text-white leading-tight mb-12">
            Precision, Passion,
            <br />
            <span className="text-[#FF6B35]">No Compromises</span>
          </h2>

          <div className="space-y-7">
            {whyChooseUs.map((item, i) => (
              <div key={i} className="flex items-start gap-5 group">
                <div className="flex flex-col items-center gap-1 flex-shrink-0">
                  <span className="text-[#FF6B35]/25 font-display font-black text-xs">0{i + 1}</span>
                  <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/15 rounded-xl border border-[#FF6B35]/20 group-hover:bg-[#FF6B35]/25 transition-colors">
                    <i className={`${item.icon} text-[#FF6B35] text-xl`} />
                  </div>
                </div>
                <div className="pt-3">
                  <strong className="text-white font-bold text-base block mb-1.5">{item.title}</strong>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12">
            <a href="#lead-form"
              className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E5501A] text-white font-bold px-6 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer text-sm">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-calendar-check-fill" /></span>
              Book Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
